import { v4 } from "uuid";
import { TApiEndpointKeys } from "../config/config";
import { ensureConfig } from "../services/configuration-service";
import { getTokenFromStorage } from "../services/authenticator-service";

export const createAuthorisedApiRequest = async (
  endpointKey: TApiEndpointKeys,
  body: object,
  method = "POST"
): Promise<{ url: string; requestInit: RequestInit }> => {
  const regionConfig = ensureConfig();
  const endpoint = regionConfig[endpointKey];
  const cognitoUrl = regionConfig.CognitoUrl;
  const clientId = regionConfig.CognitoClientId;
  const token = await getTokenFromStorage(cognitoUrl, clientId);

  let bodyJson: string;
  const requestId = v4(); // TODO log this, does it become tx id?
  if (Array.isArray(body)) {
    bodyJson = JSON.stringify(body);
  } else {
    bodyJson = JSON.stringify({
      RequestId: requestId,
      ...body,
    });
  }

  return {
    url: endpoint,
    requestInit: {
      method,
      headers: {
        Authorization: `Bearer ${token?.idtoken ?? ""}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },

      body: bodyJson,
    },
  };
};
